// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"c763d203","453":"ed67de94"}[chunkId] + ".chunk.js";
};